import type { WorkBook } from 'xlsx';

import {
  scanCatalogWorkbook,
  type CatalogSheetRow,
  type CatalogWorklistBuckets,
} from './catalogWorklist';
import type { FlaggedWebNoPriceRow } from './types';

/**
 * Flat or stacked WEBNOPRF* headers. Stacked Client Access rows join to
 * `PRODUCT NUMBER`, `USER DEF-2 1 CHAR`, …
 */
export const WEB_NO_PRICE_HEADERS = [
  'DIV',
  'NUMBER',
  'USER DEF-2',
  'USER DEF-9',
] as const;

export type WebNoPriceAnalysis = CatalogWorklistBuckets<FlaggedWebNoPriceRow>;

function toFlaggedWebNoPrice(input: CatalogSheetRow): FlaggedWebNoPriceRow {
  const userDef2 = input.cell('USER DEF-2');
  const userDef9 = input.cell('USER DEF-9');
  return {
    fileName: input.fileName,
    sheetName: input.sheetName,
    sheetRow: input.sheetRow,
    div: input.cell('DIV'),
    productNumber: input.cell('NUMBER'),
    description: input.cell('ENGLISH DESCRIPTION'),
    productType: input.cell('TYPE'),
    inStock: input.cell('STOCK (Y/N)'),
    recordStatus: input.cell('STATUS'),
    userDef2,
    userDef9,
    reasons: [
      {
        id: 'webFlaggedNoPrice',
        column: 'USER DEF-2',
        value: userDef2,
      },
    ],
  };
}

/**
 * WEBNOPRF*: every product row is a web-flagged item with no price record.
 * Scan all DC tabs — the WJ stem can be empty while WB holds the row.
 */
export function analyzeWebNoPrice(
  workbook: WorkBook,
  fileName: string,
): WebNoPriceAnalysis | null {
  return scanCatalogWorkbook({
    workbook,
    fileName,
    requiredHeaders: WEB_NO_PRICE_HEADERS,
    productHeader: 'NUMBER',
    toFlagged: toFlaggedWebNoPrice,
  });
}
